<template>
    <div>
        <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
          <div class="home-donations app-bg-gradient">
            <div class="stars-bg"></div>
            <Languages class="languages" v-bind:settings="true"></Languages>
            <div class="mosque-name">{{user.data.name}}</div>
            <div class="hint">{{"Please Touch a donation type" | translate}}</div>
            <div class="main-height">
              <div class="reports-section" v-bind:items="user.data.donationCategories.length" v-if='!clickOther'>
                <div class="masjid-fund main-donations" v-bind:key="option.id" v-for="option in user.data.donationCategories">
                  <div class="glow"><img src="/static/images/glow.png"/></div>
                  <donationOption class="cursor"
                  @clickOption="setDonationType"
                  v-bind:option='option'></donationOption>
                </div>
              </div>

              <div class="reports-section other-child-options-sec" v-if='clickOther'>
                <div class="masjid-fund other-donations" v-if="option.id === 4" v-for="option in user.data.donationCategories" v-bind:key="option.id">
                  <!--<div class="child-options" @click="setDonationType(category)"  v-bind:style="{width: 'calc(100% /' + option.childCategories.length+')'}" v-for="category in option.childCategories">-->
                  <div class="child-options" @click="setDonationType(category)" v-for="category in option.childCategories" v-bind:key="category.id">
                    <div class="glow"><img src="/static/images/glow.png"/></div>
                    <childDonationOptions class="cursor" v-bind:childOption="category">
                    </childDonationOptions>
                  </div>
                  <div class="child-options back-label cursor" @click="backToMainDonations">{{"Back" | translate}}</div>
                </div>
              </div>
            </div>
            <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
          </div>
        </div>
        <div class="full-screen reports-section other-reports-section" style="display: none">
            <div class="musallah">
                <div class="donation-details">
                    <div>
                        <img src="static/images/musallah.png" />
                    </div>
                    <div class="title">{{musallah | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(musallah)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="madarasa">
                <div class="donation-details">
                    <div>
                        <img src="static/images/madarasa.png" />
                    </div>
                    <div class="title">{{madarasa | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(madarasa)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="iftiar">
                <div class="donation-details">
                    <div>
                        <img src="static/images/iftiar.png" />
                    </div>
                    <div class="title">{{iftiar | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(iftiar)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="imam-salary">
                <div class="donation-details">
                    <div>
                        <img src="static/images/imam-salary.png" />
                    </div>
                    <div class="title">{{imamSalary | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(imamSalary)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="funeral">
                <div class="donation-details">
                    <div>
                        <img src="static/images/funeral.png" />
                    </div>
                    <div class="title">{{funeral | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(funeral)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="flods">
                <div class="donation-details">
                    <div>
                        <img src="static/images/flods.png" />
                    </div>
                    <div class="title">{{flods | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(flods)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="earth-quicks">
                <div class="donation-details">
                    <div>
                        <img src="static/images/earth-quicks.png" />
                    </div>
                    <div class="title">{{earthQuicks | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(earthQuicks)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="construction">
                <div class="donation-details">
                    <div>
                        <img src="static/images/construction.png" />
                    </div>
                    <div class="title">{{construction | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(construction)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="sadqaEFitr">
                <div class="donation-details">
                    <div>
                        <img src="static/images/other-donations.png" />
                    </div>
                    <div class="title">{{sadqaEFitr | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(sadqaEFitr)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="masjidMembership">
                <div class="donation-details">
                    <div>
                        <img src="static/images/other-donations.png" />
                    </div>
                    <div class="title">{{masjidMembership | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(masjidMembership)"> Continue &#8250;</div>
                </div>
            </div>
            <div class="fundsfOMasques">
                <div class="donation-details">
                    <div>
                        <img src="static/images/other-donations.png" />
                    </div>
                    <div class="title">{{fundsfOMasques | translate}}</div>
                    <div class="desc">{{zakathDesc | translate}}</div>
                    <div class="continue" @click="setDonationType(fundsfOMasques)"> Continue &#8250;</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import donationOption from './donationOption.vue'
import childDonationOptions from './child-donation-options.vue'
import Languages from './Languages'

export default {
  name: 'Home',
  data () {
    return {
      activeColor: 'red',
      zakathDesc: 'Purify your wealth by giving Zakah',
      zakath: 'Zakah',
      mfund: 'Mosque Fund',
      od: 'Other Donations',
      sadaqah: 'Sadaqah',
      clickOther: false,
      musallah: 'Musallah',
      madarasa: 'Madarasa',
      imamSalary: 'Imam Salary',
      iftiar: 'Iftiar',
      funeral: 'Funeral',
      flods: 'Flods',
      earthQuicks: 'Earth Quicks',
      construction: 'Constructions',
      sadqaEFitr: 'Sadqa-e-Fitr',
      masjidMembership: 'Masjid Membership',
      fundsfOMasques: 'Fund for other mosque',
      tid: null,
      replaceRoote: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'donationType'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'changeDonationType',
      'resetEmailStatus',
      'updatePaymentRequestStatus'
    ]),
    activeOtherDonations () {
      this.clickOther = true
    },
    backToMainDonations () {
      this.clickOther = false
      clearTimeout(this.replaceRoote)
    },
    setDonationType (donation) {
      clearTimeout(this.replaceRoote)
      if (donation.id === 4) {
        if (donation.childCategories) {
          this.clickOther = true
          this.replaceRoote = setTimeout(() => {
            this.clickOther = false
          }, (1000 * 60 * 2))
        } else {
          clearTimeout(this.replaceRoote)
        //   this.changeDonationType(donation.title)
          this.$router.push({path: `/${this.tid}/amount-select/${donation.title}`})
        }
      } else {
        clearTimeout(this.replaceRoote)
        // this.changeDonationType(donation.title)
        this.$router.push({path: `/${this.tid}/amount-select/${donation.title}`})
      }
    }
  },
  destroyed: function () {
    clearTimeout(this.replaceRoote)
  },
  components: {
    donationOption,
    childDonationOptions,
    Languages
  },
  mounted: function () {
    localStorage.removeItem('payment-status')
    localStorage.removeItem('payment-req-status')
    localStorage.removeItem('donation-type')
    localStorage.removeItem('donation-amount')
    localStorage.removeItem('email-status')
    // this.updatePaymentRequestStatus('Please wait')
    this.resetEmailStatus()
    this.tid = this.$route.params.terminalId
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .full-screen {
    background-position: center;
  }
  .home-donations {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
    .bg-img {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        transform: scaleX(-1);
    }
    .main-height {
      width: 100%;
    }
    .reports-section {
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      width: 90%;
      padding: 10px 0;
      background: transparent;
      align-items: center;
      justify-content: space-between;
      height: calc(100vh - 180px);
      z-index: 2;
    }
    .other-child-options-sec {
      width:80% !important;
    }
    .logo {
      position: absolute;
      width: 150px;
      z-index: 5;
      left: 42px;
      top: 14px;
    }
    .reports-section[items="1"] > div,
    .reports-section[items="2"] > div,
    .reports-section[items="3"] > div,
    .reports-section[items="4"] > div {
      width: 50% !important;
    }
    .reports-section div.main-donations{
      width: 33.3%;
      /* width: 50%; */
      height: 50%;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
    }
    .other-donations {
      width: 100%;
      height: 100%;
      display: flex;
      position: relative;
      flex-wrap: wrap;
      align-items: center !important;
      justify-content: center !important;
    }
    .other-donations > div {
      width: 25%;
      height: 33%;
      position: relative;
      z-index: 3;
    }
    .mosque-name {
      font-size: 40px;
      color: #FFF;
      font-family: "Lato";
      font-weight: bold;
      text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
      margin-top: 61px;
      margin-bottom: 50px;
      letter-spacing: 2px;
    }
    .hint {
      color: #880913;
      font-size: 22px;
      text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.34 );
      text-transform: uppercase;
      letter-spacing: 2px;
      margin-bottom: 10px;
      font-weight: 600;
    }
    .back {
      position: absolute;
      left: 50px;
      top: 150px;
      color: #FFF;
      font-size: 18px;
      text-transform: uppercase;
      cursor: pointer;
    }
    div[dir='rtl'] .logo {
      z-index: 2;
      right: 42px;
    }
    .glow {
      position: absolute;
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .back-label {
      display:flex;align-items:center;justify-content:center;font-weight:600;font-size:26px;color:#FFF;
    }
    .other-donations .glow img {
      width: 110%;
      height: 115%;
    }
    @media only screen and (min-width: 2000px) {
      .mosque-name {
        font-size: 180px;
        line-height: 230px;
        margin-top: 10%;
        margin-bottom: 5%;
      }
      .hint {
        font-size: 100px;
        line-height: 120px;
        margin-bottom: 5%;
      }
      .reports-section {
        height: 60vh;
        width: 80%;
      }
      .reports-section div.main-donations {
        height: 43%;
      }
      .glow img {
        width: 100%;
        height: 150%;
      }
      .footer {
        font-size: 75px;
        line-height: 75px;
        bottom: 50px;
        right: 5%;
      }
      .other-child-options-sec {
        width:95% !important;
      }
      .back-label {
        font-size: 120px;
      }
    }
 @media screen and (min-width: 1200px) and (min-height: 904px) {
    .reports-section {
      width: 85% !important;
      height: 90%;
    }
    .other-child-options-sec {
      width: 90% !important;
    }
    .donation-details {
      height: 100%;
    }
    .main-height {
      height: 75vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Donation-options.vue